const menuItems = {
  items: [
    {
      id: 'navigation',
      title: 'Navigation',
      type: 'group',
      roles: ['accounts', 'sales', 'operations', 'admin', 'ci_admin', 'customer'],
      icon: 'icon-navigation',
      children: [

        {
          id: 'admindashboard',
          title: 'Admin Dashboard',
          type: 'item',
          icon: 'feather icon-box',
          url: '/dashboard/admin',
          roles: ['admin']
        },
        {
          id: 'salesdashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'feather icon-box',
          url: '/dashboard/sales',
          roles: ['sales']
        },
        {
          id: 'operationsdashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'feather icon-box',
          url: '/dashboard/operations',
          roles: ['operations']
        },
        {
          id: 'accountsdashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'feather icon-box',
          url: '/dashboard/accounts',
          roles: ['accounts']
        },
                {
          id: 'petty-cash-finance',
          title: 'Petty Cash Requests',
          type: 'item',
          icon: 'feather icon-box',
          url: '/accounts/petty-cash-requests',
          roles: ['accounts']
        },
        {
          id: 'ci-petty-cash-finance',
          title: 'Petty Cash — C&I',
          type: 'item',
          icon: 'feather icon-credit-card',
          url: '/accounts/ci-petty-cash',
          roles: ['accounts', 'admin']
        },
        {
          id: 'onboarding-dashboard',
          title: 'OnBoarding-Dashboard',
          type: 'item',
          icon: 'feather icon-box',
          url: '/accounts/onboardingform-dashboard',
          roles: ['accounts']
        },
      {
        id: 'cidashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'feather icon-box',
          url: '/dashboard/commercial',
          roles: ['ci_admin']
        },
          {
          id: 'customerdashboard',
          title: 'Dashboard',
          type: 'item',
          icon: 'feather icon-navigation',
          url: '/dashboard/customer',
          roles: ['customer']
        },
      ]
    },
      {
      id: 'customerdashboard',
      title: 'Navigation',
      type: 'group',
      icon: 'icon-navigation',
      roles: ['customer'],
      children: []
    },
    {
      id: 'SalesManagement',
      title: 'SalesManagement',
      type: 'group',
      icon: 'icon-inbox',
      roles: ['sales'],
      children: [
        // Pehle yahan 'forms' collapse group tha. Ab uske saare items direct hain.
        {
          id: 'searchcustomer',
          title: 'Search Customers',
          type: 'item',
          roles: ['sales'],
          icon:'feather icon-search',
          url: '/sales/search-customers'
        },
        {
          id: 'addcustomer',
          title: 'Add Customer',
          type: 'item',
          roles: ['sales'],
          icon:'feather icon-user-plus',
          url: '/sales/add-customer'
        },
        {
          id: 'listsalesorders',
          title: 'Sales Orders',
          type: 'item',
          roles: ['sales'],
          icon:'feather icon-book',
          url: '/sales/list-sales-orders'
        },
        {
          id: 'listsalejoblist',
          title: 'Job Orders',
          type: 'item',
          roles: ['sales'],
          icon:'feather icon-list',
          url: '/sales/list-job-orders'
        }
      ]
    },
    {
      id: 'OpsManagement',
      title: 'Operations',
      type: 'group',
      icon: 'icon-inbox',
      roles: ['operations'],
      children: [
        {
          id: 'team-management',
          title: 'Team Management',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['operations'],
          url: '/operations/team-management'
        },
        {
          id: 'vehicle-machinery-management',
          title: 'Vehicle & Machinery Management',
          type: 'item',
          icon: 'feather icon-printer',
          roles: ['operations'],
          url: '/operations/vehicle-machinery-management'
        },
        {
          id: 'joborderlist',
          title: 'Job Order List',
          type: 'item',
          roles: ['operations'],
          icon:'feather icon-list',
          url: '/operations/list-job-orders'
        },
       {
          id: 'employee-management-form',
          title: 'Employee Hiring Questionnaire',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['operations'],
          url: '/operations/employee-management-form'
        },
       {
          id: 'employee-management',
          title: 'Employee Applications',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['operations'],
          url: '/operations/employee-management'
        },
        {
          id: 'hired-employee',
          title: 'Hiring Applications',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['operations'],
          url: '/operations/hired-employee'
        },
        {
          id: 'onboarding-form',
          title: 'OnBoarding Form',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['operations'],
          url: '/operations/onboarding-form'
        },
        {
          id: 'profile-page',
          title: 'Profile Page',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['operations'],
          url: '/operations/profile-page'  
        },
        {
          id: 'petty-cash',
          title: 'Apply Petty Cash',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['operations'],
          url: '/operations/petty-cash'
        },
        {
          id: 'purchase-request',
          title: 'Apply Purchase Request',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['operations'],
          url: '/operations/purchase-request'  
        },
      ]
    },
    {
      id: 'AdminManagement',
      title: 'Administration',
      type: 'group',
      icon: 'icon-inbox',
      roles: ['admin'],
      children: [
        {
          id: 'team-analytics', // id: 'team-management' was duplicate, renamed to team-analytics for clarity
          title: 'Team Analytics',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['admin'],
          url: '/admin/team-analytics'
        },
        {
          id: 'job-performance',
          title: 'Job Performance',
          type: 'item',
          icon: 'feather icon-printer',
          roles: ['admin'],
          url: '/admin/job-performance'
        },
        {
          id: 'list-ci_clients',
          title: 'List C&I Clients',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['admin'],
          url: '/admin/list-clients'
        },
        {
          id: 'password-reset-requests',
          title: 'Password Resets',
          type: 'item',
          icon: 'feather icon-lock',
          roles: ['admin'],
          url: '/admin/password-reset-requests'
        },
      ]
    },

    {
      id: 'CIManagement',
      title: 'C&I Management',
      type: 'group',
      icon: 'icon-inbox',
      roles: ['ci_admin'],
      children: [
        {
          id: 'add-commercial-clients',
          title: 'Add C&I Clients',
          type: 'item',
          icon: 'feather icon-user-plus',
          roles: ['ci_admin'],
          url: '/commercial/add-clients'
        },
        {
          id: 'list-ci_clients',
          title: 'List C&I Clients',
          type: 'item',
          icon: 'feather icon-users',
          roles: ['ci_admin'],
          url: '/commercial/list-clients'
        },
        {
          id: 'site-management',
          title: 'Site Management',
          type: 'item',
          icon: 'feather icon-map-pin',
          roles: ['ci_admin'],
          url: '/commercial/site-management'
        },
        {
          id: 'commercial-sld-editor',
          title: 'Site Diagrams (SLD)',
          type: 'item',
          icon: 'feather icon-layers',
          roles: ['ci_admin'],
          url: '/commercial/sld-diagrams'
        },
        {
          id: 'commercial-sld-report',
          title: 'SLD Reports',
          type: 'item',
          icon: 'feather icon-file-text',
          roles: ['ci_admin'],
          url: '/commercial/sld-report'
        },
        {
          id: 'commercial-team-management',
          title: 'Commercial Team Management',
          type: 'item',
          icon: 'feather icon-box',
          roles: ['ci_admin'],
          url: '/commercial/team-management'
        },
        {
          id: 'commercial-team-scheduling-calender',
          title: 'Commercial Team Scheduling Calender',
          type: 'item',
          icon: 'feather icon-calendar',
          roles: ['ci_admin'],
          url: '/commercial/team-calender'
        },
        {
          id: 'commercial-job-history',
          title: 'Job History',
          type: 'item',
          icon: 'feather icon-clock',
          roles: ['ci_admin'],
          url: '/commercial/job-history'
        },
        {
          id: 'commercial-attendance',
          title: 'Attendance',
          type: 'item',
          icon: 'feather icon-user-check',
          roles: ['ci_admin'],
          url: '/commercial/attendance'
        },
        {
          id: 'commercial-fsr-photos',
          title: 'FSR Photos',
          type: 'item',
          icon: 'feather icon-image',
          roles: ['ci_admin'],
          url: '/commercial/fsr-photos'
        },
        {
          id: 'commercial-petty-cash',
          title: 'Petty Cash',
          type: 'item',
          icon: 'feather icon-credit-card',
          roles: ['ci_admin'],
          url: '/commercial/petty-cash'
        },
        {
          id: 'commercial-compliance',
          title: 'Compliance',
          type: 'item',
          icon: 'feather icon-shield',
          roles: ['ci_admin'],
          url: '/commercial/compliance'
        },
        {
          id: 'commercial-ehs',
          title: 'EHS Checklists',
          type: 'item',
          icon: 'feather icon-check-square',
          roles: ['ci_admin'],
          url: '/commercial/ehs'
        },
        {
          id: 'commercial-performance',
          title: 'Workforce Tracker',
          type: 'item',
          icon: 'feather icon-activity',
          roles: ['ci_admin'],
          url: '/commercial/performance'
        },
        {
          id: 'commercial-novaa-tracker',
          title: 'Novaa Tracker Management',
          type: 'item',
          icon: 'feather icon-watch',
          roles: ['ci_admin'],
          url: '/commercial/novaa-tracker'
        },
                {
          id: 'wrist-tracker',
          title: 'Novaa Wris Tracker',
          type: 'item',
          icon: 'feather icon-watch',
          roles: ['ci_admin'],
          url: '/commercial/Wrist-data'
        },
      ]
    }
  ]
};

export default menuItems;